module.exports = __webpack_public_path__ + "static/media/questionnaire-step3-mobile.c04bc5d7.png";